import { h, Fragment } from "preact";
import { useContext } from "preact/hooks";
import CardTemplate from "./CardTemplate";
import {

    Box,
    Typography,
    Stack,

} from "@mui/material";

import { AppContext } from "../../AppContext";
import ButtonWithTooltipAndBadge from "../Common/ButtonWithTooltipAndBadge";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import dayjs from "dayjs";
import "dayjs/locale/fr";

//import { TimeZoneFilterSensitiveLog } from "@aws-sdk/client-location";
var utc = require('dayjs/plugin/utc')
var relativeTime = require("dayjs/plugin/relativeTime");
dayjs.extend(relativeTime);
dayjs.locale("fr");
dayjs.extend(utc);

export default function AmbassadorProspectsCard({ actualDeal, id }) {
    console.log("AmbassadorProspectsCard", actualDeal.prospects, id)
    const app = useContext(AppContext);
    return (
        <CardTemplate
            title="Futurs acquéreurs"
            buttons={<div>
                {actualDeal.pub && (

                    <ButtonWithTooltipAndBadge
                        tooltip="Inviter un acquéreur à rejoindre le dossier"
                        icon={<AddCircleOutlineIcon />}
                        onclick_cb={
                            () => {
                                app.refPopUp.current.handleChangeState(
                                    { opened: true, type: "028", params: { uid: id, name: actualDeal.name } }
                                )
                            }}
                        badge={false} />
                )}
            </div>}
            content={
                <Fragment>
                    {actualDeal.pub && actualDeal.prospects && actualDeal.prospects.length > 0 &&
                        actualDeal.prospects.map((row) => (
                            <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                            >
                                <Box >
                                    <Typography variant="body1">{row.name}</Typography>
                                </Box>
                                <Box >

                                    {actualDeal.pub && actualDeal.prospects.length == 0 && (
                                        <div style="padding: 10px;">
                                            <Typography variant="body1"><em>Pas d'acquéreur</em></Typography>
                                        </div>
                                    )}
                                    {row.pf !== null && (<Box
                                        display="flex"
                                        alignItems="center"
                                        justifyContent={"space-between"}
                                    >
                                        <Box>
                                            <Stack>
                                                <Typography variant="h5">Offre à {row.pf.p} €</Typography>
                                                {row.pf !== null && (<Typography variant="body1">L'offre expire {dayjs(row.pf.d).utc().utcOffset(120).fromNow()}</Typography>)}
                                            </Stack>
                                        </Box>
                                    </Box>)}
                                    {row.pf === null && (
                                        <Box p={1}><Typography variant="body1"><em>Pas d'offre</em></Typography></Box>
                                    )}
                                </Box>
                            </Box>
                        ))}
                    {actualDeal.pub && actualDeal.prospects && actualDeal.prospects.length == 0 &&
                        <Typography variant="h6">Il n'y a pas encore d'acquéreur potentiel</Typography>
                    }
                    {!actualDeal.pub && (
                        <div style="padding: 10px;">
                            <Typography variant="h6">Le dossier de vente n'est pas encore public</Typography>
                        </div>
                    )}
                </Fragment>
            }
        />)

}